import { supabase } from '../lib/supabase'

export const fileService = {
  schemaName: 'Tickets',
  tableName: 'file',

  async getAll() {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')

      if (error) throw error

      return { success: true, data, error: null }
    } catch (error) {
      console.error('Error fetching files:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async getCommentsFilesByTicketId(ticketId) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .eq('ticketId', ticketId)
        .not('commentId', 'is', null) // Solo archivos asociados a comentarios
        .order('createdAt', { ascending: false })

      if (error) throw error

      return { success: true, data, error: null }
    } catch (error) {
      console.error(
        '[getCommentsFilesByTicketId] Error fetching files by ticketId:',
        error
      )
      return { success: false, data: null, error: error.message }
    }
  },

  async getByTicketId(ticketId) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .eq('ticketId', ticketId)
        .order('createdAt', { ascending: false })

      if (error) throw error

      return { success: true, data, error: null }
    } catch (error) {
      console.error('[getByTicketId] Error fetching files by ticketId:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async getByCommentId(commentId) {
    try {
      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .select('*')
        .eq('commentId', commentId)
        .order('createdAt', { ascending: false })

      if (error) throw error
      return { success: true, data, error: null }
    } catch (error) {
      console.error(
        '[getByCommentId] Error fetching files by commentId:',
        error
      )
      return { success: false, data: null, error: error.message }
    }
  },

  async insert(file) {
    try {
      const payload = {
        ticketId: file.ticketId,
        commentId: file.commentId ?? null,
        url: file.url,
        name: file.name,
        mimeType: file.mimeType,
        size: file.size,
        createdAt: new Date().toISOString(),
        solutionId: file.solutionId ?? null,
        uploadedBy: file.uploadedBy ?? 'system',
      }

      const { data, error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .insert(payload)
        .select()
        .single()

      if (error) throw error

      return { success: true, data, error: null }
    } catch (error) {
      console.error('[insert] Error inserting file:', error)
      return { success: false, data: null, error: error.message }
    }
  },

  async delete(id) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('id', id)

      if (error) throw error

      return { success: true, error: null }
    } catch (error) {
      console.error('[delete] Error deleting file:', error)
      return { success: false, error: error.message }
    }
  },

  async deleteBySolutionId(solutionId) {
    try {
      const { error } = await supabase
        .schema(this.schemaName)
        .from(this.tableName)
        .delete()
        .eq('solutionId', solutionId)

      if (error) throw error

      return { success: true, data: null, error: null }
    } catch (error) {
      console.error(
        '[deleteBySolutionId] Error deleting solution files:',
        error
      )
      return { success: false, error: error.message }
    }
  },
  /**
   * Si estás usando Storage con bucket público
   * y guardas solo el path en la columna url
   */
  getPublicUrl(bucketName, path) {
    const { data } = supabase.storage.from(bucketName).getPublicUrl(path)
    return data?.publicUrl ?? null
  },
}
